import Link from "next/link";
import {AboutProfile} from "@modes0/ui-components";
import {aboutPageContent, metaTagsAbout} from "@/content";
import {PageSeo} from '@modes0/ui-components-seo';
import {seoSiteProfile} from '@/content/seo';

export default function AboutPage() {
    return (
        <>
            <PageSeo meta={metaTagsAbout} siteProfile={seoSiteProfile} includeBusinessSchema />
            <AboutProfile {...aboutPageContent} Link={Link} />
        </>
    );
}
